import { render, staticRenderFns } from "./ActivityCommentAction.vue?vue&type=template&id=4e517c64&scoped=true"
import script from "./ActivityCommentAction.vue?vue&type=script&lang=ts"
export * from "./ActivityCommentAction.vue?vue&type=script&lang=ts"
import style0 from "./ActivityCommentAction.vue?vue&type=style&index=0&id=4e517c64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e517c64",
  null
  
)

export default component.exports